export default __webpack_public_path__ + "static/media/american_express.a5528966.svg";